import { AsphaltNuclearFieldDensityWorksheet } from '../AsphaltNuclearFieldDensityWorksheet';
import {
  AashtoAtterbergLimitWorksheetMethodA,
  AashtoAtterbergLimitWorksheetMethodB,
  AsAtterbergLimitWorksheetFourPoint,
  AsAtterbergLimitWorksheetFourPointWithShrinkage,
  AsAtterbergLimitWorksheetOnePoint,
  AsAtterbergLimitWorksheetOnePointWithShrinkage,
  AstmAtterbergLimitWorksheetMethodA,
  AstmAtterbergLimitWorksheetMethodB,
  AtterbergLimitPlasticLimitStandalone,
  BsEnIsoAtterbergLimitWorksheetMethodA,
  BsEnIsoAtterbergLimitWorksheetMethodB,
} from '../AtterbergLimitWorksheet';
import { AsConvertedWetDensityWorksheet } from '../ConvertedWetDensityWorksheet';
import {
  AsDynamicConePenetrometerWorksheet,
  DynamicConePenetrometerWorksheet,
} from '../DynamicConePenetrometerWorksheet';
import { HandShearVaneWorksheet } from '../HandShearVaneWorksheet';
import { LinearShrinkageWorksheet, MeasuredLinearShrinkageWorksheet } from '../LinearShrinkage';
import { BsEnLosAngelesValueWorksheet } from '../LosAngelesValueWorksheet';
import {
  AashtoMaximumDryDensityWorksheet,
  AashtoMetricMaximumDryDensityWorksheet,
  ArizMaximumDryDensityWorksheet,
  AsMaximumDryDensityWorksheet,
  AstmMaximumDryDensityWorksheet,
  AstmMetricMaximumDryDensityWorksheet,
  Bs11_3_11_4_MaximumDryDensityWorksheet,
  Bs11_5_11_6_MaximumDryDensityWorksheet,
  Bs11_7_MaximumDryDensityWorksheet,
} from '../MaximumDryDensityWorksheet';
import {
  BsC13_4MoistureConditionValueWorksheet,
  BsC13_5MoistureConditionValueWorksheet,
  BsEnMoistureConditionValueWorksheet,
} from '../MoistureConditionValueWorksheet';
import {
  AashtoMeasuredMoistureContentWorksheet,
  AashtoMoistureContentWorksheet,
  As1289_2_1_1_MeasuredMoistureContentWorksheet,
  As1289_2_1_1_MoistureContentWorksheet,
  As1289_2_1_6_MeasuredMoistureContentWorksheet,
  As1289_2_1_6_MoistureContentWorksheet,
  AstmMeasuredMoistureContentWorksheet,
  AstmMoistureContentWorksheet,
  BsEnIsoMeasuredMoistureContentWorksheet,
  BsEnIsoMoistureContentWorksheet,
  BsEnMeasuredMoistureContentWorksheet,
  BsEnMoistureContentWorksheet,
  BsMeasuredMoistureContentWorksheet,
  BsMoistureContentWorksheet,
} from '../MoistureContentWorksheet';
import {
  ArizNuclearFieldDensityWorksheet,
  AsNuclearFieldDensityWorksheet,
  BsNuclearFieldDensityWorksheet,
} from '../NuclearFieldDensityWorksheet';
import { OrganicContentWorksheet } from '../OrganicContentWorksheet';
import { ArizMeasuredOversizeCorrectionWorksheet } from '../OversizeCorrectionWorksheet';
import {
  AashtoMeasuredOversizeDeterminationWorksheet,
  ArizMeasuredOversizeDeterminationWorksheet,
  AsMeasuredOversizeDeterminationWorksheet,
  AstmMeasuredOversizeDeterminationWorksheet,
  BsC11MeasuredOversizeDeterminationWorksheet,
  BsC9_2MeasuredOversizeDeterminationWorksheet,
} from '../OversizeDeterminationWorksheet';
import { BsEnParticleDensityWorksheet, BsParticleDensityWorksheet } from '../ParticleDensityWorksheet';
import { CBRByPlateLoadingWorksheet, PlateLoadingWorksheet } from '../PlateLoadingWorksheet';
import { PsdHydrometerBsEnIsoWorksheet } from '../PsdHydrometerWorksheet';
import {
  As1141_11_1_PsdSieveAnalysisAsWorksheet,
  As1289_3_6_1_PsdSieveAnalysisWorksheet,
  PsdSieveAnalysisAashtoT27Worksheet,
  PsdSieveAnalysisAstmC136Worksheet,
  PsdSieveAnalysisAstmD6913Worksheet,
  PsdSieveAnalysisBsEnIsoWorksheet,
  PsdSieveAnalysisBsEnWorksheet,
} from '../PsdSieveAnalysisWorksheet';
import { AsRelativeCompactionWorksheet } from '../RelativeCompactionWorksheet';
import { AggregateSamplingCertificate, SoilSamplingCertificate } from '../SamplingCertificate';
import { SandReplacementWorksheet } from '../SandReplacementWorksheet';
import { MeasuredSoilClassificationEstimatedAlWorksheet } from '../SoilClassificationEstimatedAlWorksheet';
import { MeasuredSoilClassificationEstimatedPsdWorksheet } from '../SoilClassificationEstimatedPsdWorksheet';
import { AstmSoilClassificationWorksheet } from '../SoilClassificationWorksheet';
import SpecificGravityCoarseWorksheet, {
  MeasuredSpecificGravityCoarseWorksheet,
} from '../SpecificGravityCoarseWorksheet';
import {
  As1141_11_1_MeasuredWashSievingWorksheet,
  As1289_3_6_1_MeasuredWashSievingWorksheet,
  MeasuredWashAstmC117Worksheet,
  MeasuredWashAstmD6913Worksheet,
  MeasuredWashHydrometerBsEnIsoWorksheet,
  MeasuredWashSievingBsEnIsoWorksheet,
  MeasuredWashSievingBsEnWorksheet,
  WashAstmC117Worksheet,
  WashAstmD1140Worksheet,
} from '../WashWorksheet';

import { AsAssignedMaximumDryDensityWorksheet } from '../AssignedMaximumDryDensityWorksheet';
import { BinderContentWorksheet } from '../BinderContentWorksheet';
import { AsEmersonClassificationWorksheet } from '../EmersonClassificationWorksheet';
import UnsupportedWorksheet from '../UnsupportedWorksheet';
const worksheetTypeIdComponentMapping = [
  AsAtterbergLimitWorksheetFourPoint,
  AsAtterbergLimitWorksheetOnePoint,
  AsAtterbergLimitWorksheetFourPointWithShrinkage,
  AsAtterbergLimitWorksheetOnePointWithShrinkage,
  AashtoMaximumDryDensityWorksheet,
  AashtoMetricMaximumDryDensityWorksheet,
  ArizMaximumDryDensityWorksheet,
  AstmMaximumDryDensityWorksheet,
  AsMaximumDryDensityWorksheet,
  AstmMetricMaximumDryDensityWorksheet,
  Bs11_3_11_4_MaximumDryDensityWorksheet,
  Bs11_5_11_6_MaximumDryDensityWorksheet,
  Bs11_7_MaximumDryDensityWorksheet,
  AstmAtterbergLimitWorksheetMethodA,
  AstmAtterbergLimitWorksheetMethodB,
  AashtoAtterbergLimitWorksheetMethodA,
  AashtoAtterbergLimitWorksheetMethodB,
  BsEnIsoAtterbergLimitWorksheetMethodA,
  BsEnIsoAtterbergLimitWorksheetMethodB,
  AtterbergLimitPlasticLimitStandalone,
  OrganicContentWorksheet,
  AashtoMoistureContentWorksheet,
  As1289_2_1_1_MoistureContentWorksheet,
  As1289_2_1_6_MoistureContentWorksheet,
  AstmMoistureContentWorksheet,
  BsMoistureContentWorksheet,
  BsEnIsoMoistureContentWorksheet,
  BsEnMoistureContentWorksheet,
  AstmSoilClassificationWorksheet,
  SpecificGravityCoarseWorksheet,
  As1141_11_1_PsdSieveAnalysisAsWorksheet,
  As1289_3_6_1_PsdSieveAnalysisWorksheet,
  PsdSieveAnalysisAstmD6913Worksheet,
  PsdSieveAnalysisAstmC136Worksheet,
  PsdSieveAnalysisAashtoT27Worksheet,
  PsdSieveAnalysisBsEnIsoWorksheet,
  PsdSieveAnalysisBsEnWorksheet,
  WashAstmC117Worksheet,
  WashAstmD1140Worksheet,
  ArizNuclearFieldDensityWorksheet,
  BsNuclearFieldDensityWorksheet,
  AsNuclearFieldDensityWorksheet,
  HandShearVaneWorksheet,
  SoilSamplingCertificate,
  AggregateSamplingCertificate,
  DynamicConePenetrometerWorksheet,
  AsDynamicConePenetrometerWorksheet,
  SandReplacementWorksheet,
  PlateLoadingWorksheet,
  CBRByPlateLoadingWorksheet,
  AsphaltNuclearFieldDensityWorksheet,
  AsConvertedWetDensityWorksheet,
  LinearShrinkageWorksheet,
  BsParticleDensityWorksheet,
  BsEnParticleDensityWorksheet,
  BsC13_4MoistureConditionValueWorksheet,
  BsC13_5MoistureConditionValueWorksheet,
  BsEnMoistureConditionValueWorksheet,
  BsEnLosAngelesValueWorksheet,
  AsRelativeCompactionWorksheet,
  AsEmersonClassificationWorksheet,
  BinderContentWorksheet,
  PsdHydrometerBsEnIsoWorksheet,
  AsAssignedMaximumDryDensityWorksheet,
].reduce((acc, worksheet) => {
  return {
    ...acc,
    ...worksheet.qestIds.reduce((acc, q) => {
      return { ...acc, [q]: worksheet };
    }, {}),
  };
}, {});

const measuredWorksheetTypeIdComponentMapping = [
  ArizMeasuredOversizeCorrectionWorksheet,
  AashtoMeasuredMoistureContentWorksheet,
  As1289_2_1_1_MeasuredMoistureContentWorksheet,
  As1289_2_1_6_MeasuredMoistureContentWorksheet,
  AstmMeasuredMoistureContentWorksheet,
  AstmMeasuredOversizeDeterminationWorksheet,
  AashtoMeasuredOversizeDeterminationWorksheet,
  ArizMeasuredOversizeDeterminationWorksheet,
  AsMeasuredOversizeDeterminationWorksheet,
  BsC11MeasuredOversizeDeterminationWorksheet,
  BsC9_2MeasuredOversizeDeterminationWorksheet,
  BsMeasuredMoistureContentWorksheet,
  BsEnIsoMeasuredMoistureContentWorksheet,
  BsEnMeasuredMoistureContentWorksheet,
  MeasuredSoilClassificationEstimatedPsdWorksheet,
  MeasuredSoilClassificationEstimatedAlWorksheet,
  MeasuredSpecificGravityCoarseWorksheet,
  MeasuredWashAstmC117Worksheet,
  MeasuredWashAstmD6913Worksheet,
  MeasuredWashSievingBsEnWorksheet,
  MeasuredWashSievingBsEnIsoWorksheet,
  MeasuredWashHydrometerBsEnIsoWorksheet,
  MeasuredLinearShrinkageWorksheet,
  As1141_11_1_MeasuredWashSievingWorksheet,
  As1289_3_6_1_MeasuredWashSievingWorksheet,
].reduce((acc, worksheet) => {
  return {
    ...acc,
    ...worksheet.qestIds.reduce((acc, q) => {
      return { ...acc, [q]: worksheet };
    }, {}),
  };
}, {});

export const getWorksheetComponent = (id) => worksheetTypeIdComponentMapping[id] ?? UnsupportedWorksheet;
export const getMeasuredWorksheetComponent = (id) => measuredWorksheetTypeIdComponentMapping[id];
